import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../services/Api";

const initialState = {
    exportResults: [],
    isExportSearchLoading: false,
    error: null,
    exportPagination: {
        currentPage: 0,
        totalPages: 0,
        totalElements: 0,
        pageSize: 50,
    },

    isRestoring: false,
    restoreError: null,

    exportSelectedFilters: {},
};


const handleGetExportSearchResultsSuccess = (state, action) => {
    const pageDto = action.payload; 
    const {
        content = [],
        page_number = 0,
        total_pages = 0,
        total_result = 0,
        page_size = 50,
    } = pageDto || {};

    return updateObject(state, {
        isExportSearchLoading: false,
        exportResults: content,
        error: null,
        exportPagination: {
            currentPage: page_number,
            totalPages: total_pages,
            totalElements: total_result,
            pageSize: page_size,
        },
    });
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_EXPORT_SEARCH_RESULTS_REQUEST:
            return updateObject(state, { isExportSearchLoading: true, error: null });

        case actionTypes.GET_EXPORT_SEARCH_RESULTS_SUCCESS:
            return handleGetExportSearchResultsSuccess(state, action);

        case actionTypes.GET_EXPORT_SEARCH_RESULTS_FAILURE:
            return updateObject(state, { isExportSearchLoading: false, error: action.error });

        case actionTypes.RESTORE_ITEMS_REQUEST:
            return updateObject(state, { isRestoring: true, restoreError: null });
        case actionTypes.RESTORE_ITEMS_SUCCESS:
            return updateObject(state, { isRestoring: false });
        case actionTypes.RESTORE_ITEMS_FAILURE:
            return updateObject(state, { isRestoring: false, restoreError: action.error });

        case actionTypes.SET_EXPORT_SELECTED_FILTERS:
            return updateObject(state, { exportSelectedFilters: action.payload });


        default:
            return state;
    }
};

export default reducer;